import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import numeral from 'numeral';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
import List from '../../components/List';

const Leaderboard = (props) => {
  // State
  const [item, setItem] = useState(props || null);

  // Hooks
  const game = useSelector((state) => state.game);
  // const dispatch = useDispatch();

  // Effects
  useEffect(() => {
    if (game?.data) {
      setItem(game.data);
    }
  }, [game?.data]);

  // Logic
  const playersData = item?.players?.map((p) => {
    const latestResult = p.results?.[p.results.length - 1];

    return {
      name: p.name,
      lastname: p.lastname,
      email: p.email,
      result: latestResult ? String(latestResult['contractExtended']) : '-',
    };
  });

  return (
    <div>
      <Header />

      <h2 className='mt-3 sec-title fs-3'>
        Leaderboard
        <small className='float-end'>
          <DebriefMenu game_id={game.data._id} location={props?.location} />
        </small>
      </h2>

      <div style={{ fontSize: '14px' }}>
        <List
          labels={['Name', 'Lastname', 'Email', 'Result']}
          fields={['name', 'lastname', 'email', 'result']}
          sortables={['email']}
          data={playersData}
        />
      </div>
    </div>
  );
};

export { Leaderboard as GameLeaderboard };
